import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vSelect from 'vue-select';
import VueGoodTablePlugin from 'vue-good-table';
import { startup as authStartup } from '@/core/auth';
import { datePlugin, componentsPlugin, utilsPlugin } from '@/shared/plugins';
import { userMixin } from '@/modules/user/mixins/user.mixin';
import { commonMixin } from '@/modules/common/mixins/common.mixin';
import {
  date,
  dateTime,
  phone,
  studentSie,
  price,
  currency,
  ssn,
  capitalize,
  daywithnumber,
  formatDateWithHour,
  formatDateAsDay,
  hourFilter,
  emptyFilter,
  boolText,
  upperCaseFilter,
  formatNumber,
  appointmentFormat,
} from './filters';
import 'vue-good-table/dist/vue-good-table.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

//filters
Vue.filter('phone', phone);
Vue.filter('studentSie', studentSie);
Vue.filter('price', price);
Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('dateTime', dateTime);
Vue.filter('ssn', ssn);
Vue.filter('capitalize', capitalize);
Vue.filter('daywithnumber', daywithnumber);
Vue.filter('formatDateWithHour', formatDateWithHour);
Vue.filter('formatDateAsDay', formatDateAsDay);
Vue.filter('hour', hourFilter);
Vue.filter('empty', emptyFilter);
Vue.filter('boolText', boolText);
Vue.filter('uppercase', upperCaseFilter);
Vue.filter('formatNumber', formatNumber);
Vue.filter('appointmentFormat', appointmentFormat);

// plugins
import './plugins/vee-validate';
import './plugins/vue-meta';
import './plugins/boostrap-vue';

Vue.use(VueGoodTablePlugin);
Vue.use(componentsPlugin);
Vue.use(datePlugin);
Vue.use(utilsPlugin);

// core
import './core/vue/error-handler';

// mixins
import '@/mixins/vue-alerts';
Vue.mixin(userMixin);
Vue.mixin(commonMixin);

// styles
import '@/scss/main.scss';
import '@/scss/old/style-old.scss';
import '@/assets/css/all.css';
import '@/assets/css/solid.css';
import '@/assets/css/style.css';
import '@/assets/css/mobile.css';
import 'CustomUserInfoPanel/scss/main.scss';

//components
Vue.component('v-select', vSelect);

authStartup().then((ok) => {
  if (ok) {
    new Vue({
      store,
      router,
      mounted() {
        if (this.isTrainingEnv()) {
          const favicon = document.getElementById('favicon');
          favicon.href = '/favicon-training.ico';
        }
      },
      render: (h) => h(App),
    }).$mount('#app');
  }
});
